import { useState } from "react"
import Lottie from 'lottie-react';
import AnimationData from './scroll.json';

export function UI({portalState,isMobile,lunchAnimation,setLunchAnimation,setPortalState, setCLickedByHam,clickedbyHam,startExperience, setStartExperience, setHelpState , helpState, contactState,setContactState,contactPage,setContactPage,...props}) {
  const [hamburgerMenuOpen, setHamburgerMenuOpen] = useState(false);
  return (
    <>

<div className="fixed top-4 right-4 z-50">
<button
onClick={() => setLunchAnimation(!lunchAnimation)}
>
<h1
  className={`py-[min(2vh,0.5rem)] px-[min(10vw,1rem)] bg-orange-400 text-white font-black overflow-hidden rounded-lg cursor-pointer transition-colors duration-400 text-[min(12vw,1rem)] duration-800 [box-shadow:5px_5px_rgb(200_82_82)]
  active:bg-orange-700 active:scale-95 active:[box-shadow:2px_2px_rgb(200_82_82)]
  sm:hover:bg-orange-600 sm:hover:translate-x-[3px] sm:hover:translate-y-[3px] sm:hover:[box-shadow:0px_0px_rgb(132_60_82)]
  ${startExperience === true ? "" : "hidden"}
  `}
>
  SPINS
</h1>
    </button>
</div>






<div className={`fixed top-4 left-4 z-[200] ${startExperience === true ? "" : "hidden"}
      `}>
  <button
    onClick={() => setHamburgerMenuOpen(!hamburgerMenuOpen)}
    className="p-2 rounded-lg text-white font-bold focus:outline-none"
  >
    <div className={`${
      hamburgerMenuOpen ? "space-y-1.5" : "space-y-1"
    } transition-all duration-300 ease-in-out z-101`}>
      <div className="w-8 h-1 bg-white rounded"></div>
      <div className="w-8 h-1 bg-white rounded"></div>
      <div className="w-8 h-1 bg-white rounded"></div>
    </div>
  </button>
  
  <div
    className={`${
      hamburgerMenuOpen ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0 pointer-events-none"
    } text-white absolute top-12 left-0 p-4 rounded-lg transform transition-all duration-300 ease-in-out`}
  >
    <ul className="space-y-2">
      <li>
        <button onClick={() => {
          setPortalState(0) 
          setHelpState(false)
          setContactState(false)
          setHamburgerMenuOpen(!hamburgerMenuOpen)
          }} className="py-[min(6vh,1rem)] px-[min(6vw,2rem)] bg-orange-400 text-white font-black overflow-hidden rounded-lg hover:bg-orange-600 cursor-pointer transition-colors duration-400 text-[min(12vw,1rem) duration-800 [box-shadow:5px_5px_rgb(200_82_82)] hover:translate-x-[3px] hover:translate-y-[3px] hover:[box-shadow:0px_0px_rgb(132_60_82)]">Home</button>
      </li>
      <li>
        <button onClick={() => {
          setPortalState(0)
          setContactState(true)
          setHelpState(false)
          setCLickedByHam(true)
          setHamburgerMenuOpen(!hamburgerMenuOpen)
        }} className="py-[min(6vh,1rem)] px-[min(6vw,2rem)] bg-orange-400 text-white font-black overflow-hidden rounded-lg hover:bg-orange-600 cursor-pointer transition-colors duration-400 text-[min(12vw,1rem) duration-800 [box-shadow:5px_5px_rgb(200_82_82)] hover:translate-x-[3px] hover:translate-y-[3px] hover:[box-shadow:0px_0px_rgb(132_60_82)]">Contact</button>
      </li>
      <li>
      <button onClick={() => {
          setPortalState(1) 
          setHelpState(false)
          setContactState(false)
          setHamburgerMenuOpen(!hamburgerMenuOpen)
          }} className="py-[min(6vh,1rem)] px-[min(6vw,2rem)] bg-orange-400 text-white font-black overflow-hidden rounded-lg hover:bg-orange-600 cursor-pointer transition-colors duration-400 text-[min(12vw,1rem) duration-800 [box-shadow:5px_5px_rgb(200_82_82)] hover:translate-x-[3px] hover:translate-y-[3px] hover:[box-shadow:0px_0px_rgb(132_60_82)]">Skills</button>
      </li>
      <li>
        <button onClick={() => {
          setPortalState(2) 
          setHelpState(false)
          setContactState(false)
          setHamburgerMenuOpen(!hamburgerMenuOpen)
          }} className="py-[min(6vh,1rem)] px-[min(6vw,2rem)] bg-orange-400 text-white font-black overflow-hidden rounded-lg hover:bg-orange-600 cursor-pointer transition-colors duration-400 text-[min(12vw,1rem) duration-800 [box-shadow:5px_5px_rgb(200_82_82)] hover:translate-x-[3px] hover:translate-y-[3px] hover:[box-shadow:0px_0px_rgb(132_60_82)]">Experiences</button>
      </li>
    </ul>
  </div>
</div>












<div className="fixed inset-0 pointer-events-none">
      <section className="flex w-full h-screen flex-col items-center justify-center p-0 duration-500">
        {/* Title */}
        <h1
          className={`text-[min(12vw,2.2rem)] font-bold text-white uppercase mb-1 tracking-widest text-center
          ${startExperience === false ? "" : "hidden"}
          `}
        >
          HEY WELCOME
        </h1>
        <p
          className={`font-bold text-white text-center text-[min(8vw,1.1rem)] max-w-[800px]
          ${startExperience === false ? "" : "hidden"}
          `}
        >
          I'm Baptiste, a System Engineer who lives and work in Madrid.
        </p>
        <p
          className={`font-bold text-white text-center text-[min(8vw,1.1rem)] mb-4 max-w-[800px]
          ${startExperience === false ? "" : "hidden"}
          ${isMobile === false ? "hidden" : ""}
          `}
        >
          You can scroll up to set full screen
        </p>
        <p
          className={`font-bold text-white text-center text-[min(8vw,1.1rem)] mb-4 max-w-[800px]
          ${startExperience === false ? "" : "hidden"}
          ${isMobile === false ? "" : "hidden"}
          `}
        >
          You can click on Start to discover my portfolio
        </p>

        <div className={`
          ${isMobile === false ? "hidden" : ""}
          ${startExperience === false ? "pointer-events-auto" : "opacity-0 pointer-events-none"}
          ${startExperience === false ? "" : "hidden"}`}>
          <Lottie
            animationData={AnimationData}
            loop={true}
            autoplay={true}
            style={{ 
              width: '100%', 
              height: '100%',
              transform: 'rotate(180deg)',
              filter: 'invert(1)'
            }}
          />
        </div>
        
        <div className="h-[70%]"></div>

        {/* Button container */}
        <div className="flex space-x-4 sm:space-x-10 justify-center absolute bottom-8 pointer-events-auto">
          {/* NEXT Button */}
          <button
            onClick={() => setPortalState((portalState + 1) % 3)}
            className={`py-[min(12vh,0.8rem)] px-[min(10vw,1.7rem)] bg-orange-400 text-white font-black overflow-hidden rounded-lg cursor-pointer transition-colors duration-400 text-[min(12vw,1rem)] duration-800 [box-shadow:5px_5px_rgb(200_82_82)]
            active:bg-orange-700 active:scale-95 active:[box-shadow:2px_2px_rgb(200_82_82)]
            sm:hover:bg-orange-600 sm:hover:translate-x-[3px] sm:hover:translate-y-[3px] sm:hover:[box-shadow:0px_0px_rgb(132_60_82)]
            ${helpState === false && startExperience === true && contactState === false ? "" : "hidden"}
            `}
          >
            NEXT
          </button>

         

          {/* HELP Button */}
          <button
            onClick={() => setHelpState(true)}
            className={`py-[min(12vh,0.8rem)] px-[min(12vw,1.7rem)] bg-orange-400 text-white font-black overflow-hidden rounded-lg hover:bg-orange-600 cursor-pointer transition-colors duration-400 text-[min(12vw,1rem) duration-800 [box-shadow:5px_5px_rgb(200_82_82)] hover:translate-x-[3px] hover:translate-y-[3px] hover:[box-shadow:0px_0px_rgb(132_60_82)]
              ${helpState === false && startExperience === true && portalState !== 0 ? "" : "hidden"}
            `}
          >
            HELP
          </button>


          {/* CONTACT Button */}
          <button
            onClick={() => setContactState(true)}
            className={`py-[min(12vh,0.8rem)] px-[min(12vw,1.7rem)] bg-orange-400 text-white font-black overflow-hidden rounded-lg hover:bg-orange-600 cursor-pointer transition-colors duration-400 text-[min(12vw,1rem) duration-800 [box-shadow:5px_5px_rgb(200_82_82)] hover:translate-x-[3px] hover:translate-y-[3px] hover:[box-shadow:0px_0px_rgb(132_60_82)]
              ${startExperience === true && portalState === 0 && contactState === false ? "" : "hidden"}
            `}
          >
            CONTACT
          </button>
        </div>
      </section>
    </div>



<div className="fixed inset-0 pointer-events-none">
      <section
        className={`flex w-full h-full flex-col items-center justify-center duration-500 
        `}
      >
        <div className="h-[80%]"></div>
        <button onClick={() =>
          portalState === 0 ? setContactState(false) : setHelpState(false)
        }
          className={`py-[min(12vh,1rem)] px-[min(12vw,2rem)] bg-orange-400 text-white font-black overflow-hidden rounded-lg hover:bg-orange-600 cursor-pointer transition-colors duration-400 transition delay-750 text-[min(12vw,1rem) duration-800 [box-shadow:5px_5px_rgb(200_82_82)] animate-bounce hover:animate-none hover:translate-x-[3px] hover:translate-y-[3px] hover:[box-shadow:0px_0px_rgb(132_60_82)]
          ${helpState === true || contactState === true ? "pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        >
          EXIT
        </button>
        
      </section>
    </div>
    
    <div className="fixed inset-0 pointer-events-none">
      
      <section
        className={`flex w-full h-full flex-col items-center justify-end duration-500 pb-[10vh]
          ${startExperience === false ? "pointer-events-auto" : "opacity-0 pointer-events-none"}`}
      >
        
        <button
          onClick={() => {
            setStartExperience(true);
            setPortalState(0);
            window.scrollTo(0,1)
            /* if (document.documentElement.requestFullscreen) {
              document.documentElement.requestFullscreen();
            } 
            else if (document.documentElement.webkitRequestFullscreen) { // Safari
              document.documentElement.webkitRequestFullscreen();
            } */
          }}
          className={`py-[min(12vh,1rem)] px-[min(24vw,4rem)] bg-orange-700 text-white font-black overflow-hidden rounded-lg hover:bg-orange-600 cursor-pointer transition-colors duration-400 text-[min(12vw,1rem) duration-800 [box-shadow:5px_5px_rgb(200_82_82)] hover:translate-x-[3px] hover:translate-y-[3px] hover:[box-shadow:0px_0px_rgb(132_60_82)]
          ${startExperience === false ? "pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        >
          START
        </button>
        
      </section>
    </div>



  </>
  );
};